<mat-card-header>
    <div style="width:700px">
        <mat-card-title>
        <label class="mat-h2 bold">COLETOR DE CUSTOS</label>
        </mat-card-title>
    </div>
    <div style="width:10%; cursor:pointer;">
        <mat-icon class="btnCancel" style="position: relative; float: right; margin-right: 5px" (click)="closePopup()">cancel</mat-icon>
    </div>
</mat-card-header>
<lista-centro-custos *ngIf="CentroCustos"></lista-centro-custos>
<lista-diagrama-rede *ngIf="DiagramaRede"></lista-diagrama-rede>
<lista-ordem-interna *ngIf="OrdemInterna"></lista-ordem-interna>
<mat-action-row class="footer">
    <button mat-button color="warn" (click)="closePopup()"  matTooltip="Caso não concorde os dados preenchidos neste formulário serão perdidos">Cancelar</button>
</mat-action-row>
